import { useApiSWR } from "@/hooks/useApiSWR";
import {
	type ProjectMember,
	listMembers,
} from "@/services/project-member.service";

export function useProjectMembers(projectId: string | undefined) {
	const { data, error, isLoading } = useApiSWR<ProjectMember[]>(
		projectId ? ["project-members", projectId] : null,
		() => listMembers(projectId!),
	);
	return { members: data ?? [], error, isLoading };
}
